<template>
  <Depth1 :content="data[0]" />
</template>

<script>
import { computed, unref } from 'vue-demi'
import { useStoreGetters } from '@/store/index'
import i18n from '@/utils/i18n'
import { parseContent } from './TermsOfUse.service'
import Depth1 from './Terms/Depth1.vue'

export default {
  name: 'TermsOfUse',
  components: {
    Depth1,
  },
  setup () {
    const { publicPathLastSelectedRegion } = useStoreGetters('regions', ['publicPathLastSelectedRegion'])
    const region = computed(() => unref(publicPathLastSelectedRegion).name)
    const source = computed(() => i18n.t(`terms.vendorTermOfUse.${unref(region)}`))
    const data = computed(() => [parseContent(unref(source))])
    return {
      data,
    }
  },
}
</script>
